var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 958"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 15.6,
    height: 15.6,
    rx: 1.3,
    stroke: "#2E2E2D",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M8.43359 12.2885V2.93731C8.43359 2.64534 8.80831 2.52541 8.97784 2.76311L14.2723 10.1867C14.3874 10.3481 14.317 10.5749 14.1307 10.6428L8.83623 12.5704C8.64056 12.6417 8.43359 12.4968 8.43359 12.2885Z",
    stroke: "#2E2E2D",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M7.57031 13.31V3.95879C7.57031 3.66683 7.19559 3.54689 7.02607 3.7846L1.73162 11.2082C1.61646 11.3696 1.68687 11.5964 1.87323 11.6643L7.16768 13.5919C7.36335 13.6632 7.57031 13.5183 7.57031 13.31Z",
    stroke: "#2E2E2D",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M7.45667 9.7466L2.36395 11.2902C2.08778 11.3739 2.0775 11.7612 2.34885 11.8594L7.43926 13.7023C7.5057 13.7264 7.5785 13.7262 7.64483 13.7019L12.7805 11.8153C13.0521 11.7155 13.0389 11.3269 12.7612 11.2457L7.62784 9.74575C7.57191 9.72941 7.51243 9.7297 7.45667 9.7466Z",
    stroke: "#2E2E2D",
    strokeWidth: 0.35
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondGray);
export default __webpack_public_path__ + "static/media/diamond_gray.5581690067938a51fc4d1b01909a74c0.svg";
export { ForwardRef as ReactComponent };